import { SegmentationIds } from 'constants/segmentation';
import { SortOptions } from 'constants/collection';

export default {
  'cdp:general:price_from': 'vanaf',
  'cdp:general:product': 'Product',
  'cdp:general:products': '{amount, plural, =0 {# producten} one {# product} other {# producten}}',
  'cdp:filter:showproducts': 'Producten tonen',
  'cdp:filter:showproduct': 'Product tonen',
  'cdp:filter:close': 'Sluiten',
  'cdp:filter:foodtypes': 'Voedingstypes',
  'cdp:filter:foodtypes:nassfutter': 'Natvoer',
  'cdp:filter:foodtypes:trockenfutter': 'Droogvoer',
  'cdp:filter:foodtypes:frische-menus': "BARF-menu's",
  'cdp:filter:foodtypes:nahrungserganzung': 'Voedingssupplementen',
  'cdp:filter:foodtypes:snacks': 'Snacks',
  'cdp:filter:foodtypes:bundles': 'Voordeelpakketten',

  'cdp:filter:species': 'Diersoort',
  'cdp:filter:species:fur-hunde': 'Honden',
  'cdp:filter:species:fur-katzen': 'Katten',

  'cdp:filter:sizes': 'Grootte van het dier',
  'cdp:filter:sizes:klein': 'Klein',
  'cdp:filter:sizes:mittel': 'Middel',
  'cdp:filter:sizes:gross': 'Groot',

  'cdp:filter:sorts': 'Smaken',
  'cdp:filter:sorts:huhn': 'Kip',
  'cdp:filter:sorts:rind': 'Rund',
  'cdp:filter:sorts:ente': 'Eend',
  'cdp:filter:sorts:pute': 'Kalkoen',
  'cdp:filter:sorts:kalb': 'Kalf',
  'cdp:filter:sorts:wild': 'Wild',
  'cdp:filter:sorts:lachs': 'Zalm',
  'cdp:filter:sorts:pferd': 'Paard',
  'cdp:filter:sorts:lamm': 'Lam',
  'cdp:filter:sorts:insekten': 'Insecten',
  'cdp:filter:sorts:veggi': 'Veggie',
  'cdp:filter:sorts:vegan': 'Veganistisch',
  'cdp:filter:sorts:ziege': 'Geit',
  'cdp:filter:sorts:thunfisch': 'Tonijn',
  'cdp:filter:sorts:forelle': 'Forel',
  'cdp:filter:sorts:kanguru': 'Kangoeroe',
  'cdp:filter:sorts:kaninchen': 'Konijn',
  'cdp:filter:sorts:straus': 'Struisvogel',
  'cdp:filter:sorts:wasserbuffel': 'Waterbuffel',
  'cdp:filter:sorts:krill': 'Krill',
  'cdp:filter:sorts:sprotten': 'Sprot',
  'cdp:filter:sorts:hirsch': 'Hert',
  'cdp:filter:sorts:geflugel': 'Gevogelte',
  'cdp:filter:sorts:truthahn': 'Kalkoen',
  'cdp:filter:sorts:fisch': 'Vis',
  'cdp:filter:sorts:schwein': 'Varken',
  'cdp:filter:sorts:rind-and-kalb': 'Rund & kalf',
  'cdp:filter:sorts:vegetarisch-vegan': 'Vegetarisch / Veganistisch',
  'cdp:filter:sorts:bowls-and-similars': 'Bakjes, likmatten & drinkbakken',
  'cdp:filter:sorts:toys': 'Speelgoed',
  'cdp:filter:sorts:walking': 'Uitlaten',
  'cdp:filter:sorts:sleeping': 'Slaapplaatsen',
  'cdp:filter:sorts:other-accessories': 'Andere accessoires',

  // Used in Personalized Cdp
  'cdp:filter:sorts:duck': 'Eend',
  'cdp:filter:sorts:rabbit': 'Konijn',
  'cdp:filter:sorts:game': 'Wild',
  'cdp:filter:sorts:deer': 'Hert',
  'cdp:filter:sorts:poultry': 'Gevogelte',
  'cdp:filter:sorts:chicken': 'Kip',
  'cdp:filter:sorts:veal': 'Kalf',
  'cdp:filter:sorts:kangaroo': 'Kangoeroe',
  'cdp:filter:sorts:salmon': 'Zalm',
  'cdp:filter:sorts:turkey': 'Kalkoen',
  'cdp:filter:sorts:beef': 'Rund',
  'cdp:filter:sorts:pork': 'Varken',
  'cdp:filter:sorts:tuna': 'Tonijn',
  'cdp:filter:sorts:wild-turkey': 'Kalkoen',

  'cdp:filter:desires': 'Bijzonderheden',
  'cdp:filter:desires:getreidefrei': 'Graanvrij',
  'cdp:filter:desires:glutenfrei': 'Glutenvrij',
  'cdp:filter:desires:hypoallergen': 'Hypoallergeen',
  'cdp:filter:desires:leicht-verdaulich': 'Licht verteerbaar',
  'cdp:filter:desires:monoprotein': 'Monoproteïne',
  'cdp:filter:desires:zuckerfrei': 'Suikervrij',
  'cdp:filter:desires:kalorienreduziert': 'Caloriearm',
  'cdp:filter:desires:low-energy': 'Low Energy',
  'cdp:filter:desires:high-energy': 'High Energy',
  'cdp:filter:desires:spezielle-erkrankungen': 'Speciale aandoeningen',

  'cdp:filter:age': 'Leeftijd',
  'cdp:filter:age:adult': 'Adult',
  'cdp:filter:age:senior': 'Senior',
  'cdp:filter:age:welpe': 'Puppy',
  'cdp:filter:age:kitten': 'Kitten',
  'cdp:filter:age:junior': 'Junior',
  'cdp:filter:age:adult-1-6-jahre': 'Adult (1-6 jaar)',
  'cdp:filter:age:senior-7-jahre': 'Senior (8+ jaar)',

  'cdp:filter:line': 'Lijn',
  'cdp:filter:line:classic': 'Classic',
  'cdp:filter:line:sensitiv': 'Sensitiv',
  'cdp:filter:line:pure-meat': 'Pure Meat',
  'cdp:filter:line:extra-meat': 'Extra Meat',
  'cdp:filter:line:breed-fit': 'Breed Fit',
  'cdp:filter:line:rollen': 'Rollen',
  'cdp:filter:line:denta-snacks': 'Denta Snacks',
  'cdp:filter:line:filet-menu': 'Filet Menü',
  'cdp:filter:line:silkycream': 'Silky Cream',
  'cdp:filter:line:puremeat': 'Pure Meat',
  'cdp:filter:line:meatypate': 'Meaty Pâté',
  'cdp:filter:line:juicyfilets': 'Juicy Filets',
  'cdp:filter:line:green': 'Green',
  'cdp:filter:line:genieser-filets': 'Genießer Filets',
  'cdp:filter:line:superfood': 'Superfood',
  'cdp:filter:line:junior': 'Junior',
  'cdp:filter:line:hypocare': 'Hypocare',
  'cdp:filter:line:feinschmecker-pate': 'Feinschmecker Pate',
  'cdp:filter:line:kaltgepresst': 'Koudgeperst',
  'cdp:filter:line:mini': 'Mini',
  'cdp:filter:line:limited': 'Limited',
  'cdp:filter:line:softies': 'Softies',
  'cdp:filter:line:happchen': 'Hapjes',
  'cdp:filter:line:pasteten': 'Paté',
  'cdp:filter:line:kausnacks': 'Kauwsnacks ',
  'cdp:filter:line:saucen-menu': 'Sausmenu',
  'cdp:filter:line:akzeptanz': 'Acceptatie',
  'cdp:filter:line:creme-snack': 'Crèmesnack',
  'cdp:filter:line:soft-snacks': 'Soft Snacks ',
  'cdp:filter:line:filet-snack': 'Filet Snack ',
  'cdp:filter:line:suppe': 'Soep',
  'cdp:filter:line:vet': 'VET',
  'cdp:filter:line:mousse': 'Mousse',
  'cdp:filter:line:tasties': 'Tasties',
  'cdp:filter:line:soft': 'Soft',
  'cdp:filter:line:cookies': 'Cookies',
  'cdp:filter:line:bundle': 'Proefpakketten',
  'cdp:filter:line:knochen-and-kaurollen': 'Botten & kauwrollen',
  'cdp:filter:line:trainingssnacks': 'Trainingssnacks',
  'cdp:filter:line:zahnpflege': 'Gebitsverzorging',
  'cdp:filter:line:pasten-and-cremesnacks': "Pasta's & crèmesnacks",
  'cdp:filter:line:hundekekse': 'Hondenkoekjes',
  'cdp:filter:line:kaustreifen-and-sticks': 'Kauwstrips & sticks',
  'cdp:filter:line:toppers': 'Toppers',
  'cdp:filter:line:gefriergetrocknet': 'Gevriesdroogd',

  'cdp:filter:funktion': 'Functie',
  'cdp:filter:funktion:gelenk': 'Gewrichten',
  'cdp:filter:funktion:haut-and-fell': 'Huid & vacht',
  'cdp:filter:funktion:zeckensaison': 'Tekenseizoen',
  'cdp:filter:funktion:denta': 'Denta',
  'cdp:filter:funktion:entspannung': 'Ontspanning',
  'cdp:filter:funktion:leber': 'Lever',
  'cdp:filter:funktion:verdauung': 'Spijsvertering',
  'cdp:filter:funktion:erkaltung': 'Verkoudheid',
  'cdp:filter:funktion:digestion': 'Spijsvertering & schrokken',
  'cdp:filter:funktion:busy': 'Bezigheid',
  'cdp:filter:funktion:smart-accessories': 'Intelligentie-accessoires',

  'cdp:filter:sort-menu:label:default': 'Op relevantie',
  'cdp:filter:sort-menu:label:price-ascending': 'Prijs, oplopend',
  'cdp:filter:sort-menu:label:price-descending': 'Prijs, aflopend',
  'cdp:filter:sort-menu:label:new': 'Nieuw',
  'cdp:filter:sort-menu:label:best-selling': 'Topseller',
  'cdp:filter:sort-menu:label:title': 'Artikelnaam',
  'cdp:filter:sort-menu:aria-label-select': 'Producten sorteren',

  'cdp:filter:nutritional-needs': 'Behoefte',
  'cdp:filter:nutritional-needs:sehr-wahlerisch': 'Zeer kieskeurig',
  'cdp:filter:nutritional-needs:pickyeatercat': 'Zeer kieskeurig',
  'cdp:filter:nutritional-needs:digestioncat': 'Spijsverteringsproblemen',
  'cdp:filter:nutritional-needs:verdauungsprobleme': 'Spijsverteringsproblemen',
  'cdp:filter:nutritional-needs:unvertraglichkeiten-allergien': 'Intoleranties / Allergieën',
  'cdp:filter:nutritional-needs:haut-and-fellprobleme': 'Huid- & vachtproblemen ',
  'cdp:filter:nutritional-needs:ubergewicht': 'Overgewicht',
  'cdp:filter:nutritional-needs:overweightcat': 'Overgewicht',
  'cdp:filter:nutritional-needs:intolerancecat': 'Allergieën / Intoleranties',
  'cdp:filter:nutritional-needs:hairballcat': 'Haarbal-hulp',
  'cdp:filter:nutritional-needs:skinfurcat': 'Huid- en vachtproblemen',
  'cdp:filter:nutritional-needs:immunitycat': 'Immunity+',

  'cdp:filter:health-needs': 'Gezondheidsbehoefte',
  'cdp:filter:health-needs:gelenk': 'Gewrichten',
  'cdp:filter:health-needs:ungeziefer': 'Ongedierte- en tekenbescherming',
  'cdp:filter:health-needs:haut-and-fell': 'Huid & vacht',
  'cdp:filter:health-needs:zeckensaison': 'Tekenseizoen',
  'cdp:filter:health-needs:denta': 'Denta',
  'cdp:filter:health-needs:entspannung': 'Ontspanning',
  'cdp:filter:health-needs:leber': 'Lever',
  'cdp:filter:health-needs:verdauung': 'Spijsvertering',
  'cdp:filter:health-needs:erkaltung': 'Verkoudheid',

  'cdp:filter:feed-type': 'Voedingssoort',
  'cdp:filter:feed-type:nassfutter': 'Natvoer',
  'cdp:filter:feed-type:trockenfutter': 'Droogvoer',
  'cdp:filter:feed-type:barf': 'BARF',
  'cdp:filter:feed-type:snacks': 'Snacks',

  'cdp:filter:snack-type': 'Snacksoort',
  'cdp:filter:snack-type:knochen-and-kaurollen': 'Botten & kauwrollen',
  'cdp:filter:snack-type:trainingssnacks': 'Trainingssnacks',
  'cdp:filter:snack-type:zahnpflege': 'Gebitsverzorging',
  'cdp:filter:snack-type:pasten-and-cremesnacks': "Pasta's & crèmesnacks",
  'cdp:filter:snack-type:hundekekse': 'Hondenkoekjes',
  'cdp:filter:snack-type:kaustreifen-and-sticks': 'Kauwstrips & sticks',
  'cdp:filter:snack-type:creme-snack': 'Crèmesnacks',
  'cdp:filter:snack-type:filet-snack': 'Filetsnack',
  'cdp:filter:snack-type:suppe': 'Soepen ',
  'cdp:filter:snack-type:soft-snacks': 'Softsnacks',
  'cdp:filter:snack-type:sensitiv': 'Sensitivsnacks',
  'cdp:filter:snack-type:pasten': "Pasta's",
  'cdp:filter:snack-type:toppers': 'Toppers',
  'cdp:filter:snack-type:functional-snacks': 'Functional Snacks',
  'cdp:filter:snack-type:knuspersnacks': 'Krokante snacks',
  'cdp:filter:snack-type:zahnpflege-and-kausnacks': 'Gebitsverzorging & kauwsnacks',
  'cdp:filter:snack-type:pasten-and-softsnacks': "Pasta's & softsnacks",

  'cdp:allergy-filter:header': 'Mijn hond verdraagt geen...',
  'cdp:allergy-filter:without': 'Zonder',
  'cdp:allergy-filter:rind': 'Rund',
  'cdp:allergy-filter:getreidefrei': 'Graan',
  'cdp:allergy-filter:huhn': 'Kip',
  'cdp:allergy-filter:pute': 'Kalkoen',
  'cdp:allergy-filter:ente': 'Eend',
  'cdp:allergy-filter:fisch': 'Vis',
  'cdp:allergy-filter:kartoffel': 'Aardappel',
  'cdp:allergy-filter:lamm': 'Lam',
  'cdp:allergy-filter:pferd': 'Paard',
  'cdp:allergy-filter:ziege': 'Geit',
  'cdp:allergy-filter:suskartoffel': 'Zoete aardappel',

  'cdp:productcard:back-soon': 'Uitverkocht',

  'cdp:filter:label': 'Filter',
  'cdp:noproductsfound': 'Geen producten gevonden.',
  'cdp:similarproducts': 'Meer producten',
  'cdp:resetfilters': 'Filters resetten',
  'cdp:reset': 'Resetten',
  'cdp:toproductbutton': 'Naar product',
  'cdp:showmoreproducts': 'Alle producten tonen',

  'cdp:configureproduct': 'In winkelmandje',
  'cdp:sizes': 'Grootte',
  'cdp:packages': 'Eenheid',

  'cdp:addtocart': 'In winkelmandje',
  'cdp:buy-panel:preorder': 'Nu vooraf bestellen',
  'cdp:intervals': 'Interval',

  'cdp:availableas': 'Verkrijgbaar in',
  'cdp:petsdelifordogs': 'Pets Deli voor honden',
  'cdp:petsdeliforcats': 'Pets Deli voor katten',
  'cdp:singlepurchase': 'Eenmalige aankoop',
  'cdp:regulardelivery': 'Regelmatige levering',
  'cdp:notavailable': 'Momenteel niet beschikbaar',

  'cdp:subscription-intervals:2-weeks': 'Elke 2 weken',
  'cdp:subscription-intervals:4-weeks': 'Elke 4 weken',
  'cdp:subscription-intervals:6-weeks': 'Elke 6 weken',
  'cdp:subscription-intervals:8-weeks': 'Elke 8 weken',

  'cdp:findoutmore': 'Nu ontdekken',

  // Following translations has beend added for an A/B test
  // see https://petsdeli.atlassian.net/browse/PT-3690
  'cdp:filter:special-desires': 'Speciale behoeften',
  'cdp:filter:taste': 'Smaak',
  'cdp:filter:special-desires:fur-welpen': "Voor puppy's & jonge honden",
  'cdp:filter:special-desires:fur-senioren': 'Voor senioren',
  'cdp:filter:special-desires:getreide-glutenfrei': 'Graan- & glutenvrije receptuur',
  'cdp:filter:special-desires:ohne-kartoffeln': 'Zonder aardappelen',
  'cdp:filter:special-desires:fur-allergiker': 'Voor allergiepatiënten',
  'cdp:filter:special-desires:sensible-verdauung': 'Gevoelige spijsvertering',
  'cdp:filter:special-desires:weniger-kalorien': 'Minder calorieën',
  'cdp:filter:special-desires:fur-aktive-hunde': 'Voor actieve honden',
  'cdp:filter:special-desires:fur-kleine-rassen': 'Voor kleine rassen',

  'cdp:filter:taste:geflugel': 'Gevogelte',
  'cdp:filter:taste:rind-kalb': 'Rund & kalf',
  'cdp:filter:taste:wild': 'Wild',
  'cdp:filter:taste:fisch': 'Vis',
  'cdp:filter:taste:lamm': 'Lam',
  'cdp:filter:taste:pferd': 'Paard',
  'cdp:filter:taste:ziege': 'Geit',
  'cdp:filter:taste:kanguru': 'Kangoeroe',
  'cdp:filter:taste:insekten': 'Insecten',
  'cdp:filter:taste:vegetarisch-vegan': 'Vegetarisch / Veganistisch',
  [`cdp:filter:sort:${SortOptions.relevance}`]: 'Populariteit',
  [`cdp:filter:sort:${SortOptions.rating}`]: 'Beoordeling',
  [`cdp:filter:sort:${SortOptions['price-asc']}`]: 'Laagste prijs',
  [`cdp:filter:sort:${SortOptions['price-desc']}`]: 'Hoogste prijs',
  [`cdp:filter:sort:${SortOptions.acceptance}`]: 'Beste acceptatie',
  [`cdp:filter:sort:${SortOptions.placeholder}`]: 'Sorteren',

  'cdp:nutrition-needs-guidance:description':
    'Individuele <strong>behoeften</strong>. Individuele <strong>recepturen</strong>. Wij vinden de perfecte voeding voor jouw hond!',
  'cdp:nutrition-needs-guidance:dropwdown:bundle': 'Kies de behoefte van jouw hond',
  'cdp:nutrition-needs-guidance:dropwdown:pickyeater': 'Mijn hond is zeer kieskeurig',
  'cdp:nutrition-needs-guidance:dropwdown:intolerance': 'Mijn hond heeft intoleranties',
  'cdp:nutrition-needs-guidance:dropwdown:digestion': 'Mijn hond heeft spijsverteringsproblemen',
  'cdp:nutrition-needs-guidance:dropwdown:welpe': 'Mijn hond is een puppy',
  'cdp:nutrition-needs-guidance:dropwdown:foodaid': 'Ik wil advies krijgen',
  'cdp:nutrition-needs-guidance:dropwdown:no-help-needed': 'Ik heb geen hulp nodig',

  'cdp:toast:add-single-item': 'Goede keuze! Jouw proefpakket is toegevoegd aan het winkelmandje.',

  'cdp:standalone-cdp:headline': 'Ontdek onze variatie',
  'cdp:standalone-cdp:subheadline': 'Individuele behoeften. Individuele recepturen.',
  'cdp:standalone-cdp:subheadline:segment': 'Meer keuze',
  'cdp:standalone-cdp:load-more': 'Meer producten laden',
  [`cdp:standalone-cdp:headline:${SegmentationIds.DogAdult}`]: 'Voor volwassen honden ',
  'cdp:standalone-cdp:headline:intolerance': 'Voor honden met intoleranties',
  'cdp:standalone-cdp:headline:pickyeater': 'Voor kieskeurige honden',
  'cdp:standalone-cdp:headline:digestion': 'Voor honden met spijsverteringsproblemen',
  'cdp:standalone-cdp:headline:skin-fur': 'Voor honden met huid- & vachtproblemen',
  'cdp:standalone-cdp:headline:overweight': 'Voor honden met overgewicht',
  'cdp:standalone-cdp:headline:prevention': 'Voor honden die lang gezond moeten blijven',
  'cdp:standalone-cdp:headline:welpe': "Voor puppy's",
  'cdp:standalone-cdp:headline:senior': 'Voor senioren',
  'cdp:standalone-cdp:headline:spitz': 'Voor Keeshonden',
  'cdp:standalone-cdp:headline:chihuahua': "Voor Chihuahua's",
  'cdp:standalone-cdp:headline:shepherd-dog': 'Voor Herdershonden',
  'cdp:standalone-cdp:headline:bulldog': 'Voor Bulldoggen',
  'cdp:standalone-cdp:headline:terrier': 'Voor Terriërs',
  'cdp:standalone-cdp:headline:poodle': 'Voor Poedels',
  'cdp:standalone-cdp:headline:havanese': 'Voor Havanezers & Maltezers',
  'cdp:standalone-cdp:headline:dachshund': 'Voor Teckels',
  'cdp:standalone-cdp:headline:herdingdog': 'Voor Herdershonden',
  'cdp:standalone-cdp:headline:retriever': 'Voor Retrievers',
  [`cdp:standalone-cdp:headline:${SegmentationIds.MixedLarge}`]: 'Voor grote kruisingen',
  [`cdp:standalone-cdp:headline:${SegmentationIds.MixedSmall}`]: 'Voor kleine kruising',
  [`cdp:standalone-cdp:headline:${SegmentationIds.CatPickyEater}`]: 'Voor kieskeurige katten',
  [`cdp:standalone-cdp:headline:${SegmentationIds.CatDigestion}`]:
    'Voor katten met spijsverteringsproblemen',
  [`cdp:standalone-cdp:headline:${SegmentationIds.CatOverweight}`]: 'Voor katten met overgewicht',
  [`cdp:standalone-cdp:headline:${SegmentationIds.Kitten}`]: 'Voor kittens',
  [`cdp:standalone-cdp:headline:${SegmentationIds.IntoleranceCat}`]:
    'Voor katten met intoleranties',
  [`cdp:standalone-cdp:headline:${SegmentationIds.SkinFurCat}`]:
    'Voor katten met huid- & vachtproblemen',
  [`cdp:standalone-cdp:headline:${SegmentationIds.CatAdult}`]: 'Voor volwassen katten',
  [`cdp:standalone-cdp:headline:${SegmentationIds.CatSenior}`]: 'Voor senioren',
  [`cdp:standalone-cdp:headline:${SegmentationIds.HairballHelp}`]:
    'Voor katten met haarbalproblemen',
  'cdp:standalone-cdp:headline:withPetName': 'Meer keuze voor {petName}',

  'cdp:tile:badge:save': 'Save {amount}%',

  'cdp:pet-profile:selector:pet-profile-available:title-general-cdp:dog':
    'Selectie aanpassen aan de behoeften van mijn hond?',
  'cdp:pet-profile:selector:pet-profile-available:title-general-cdp:cat':
    'Selectie aanpassen aan de behoeften van mijn kat?',
  'cdp:pet-profile:selector:pet-profile-available:title-with-name':
    'Selectie aanpassen aan de behoeften van {petName}?',

  'cdp:product-card:variant-button:single': '1 variant tonen',
  'cdp:product-card:variant-button:multiple': '{amount} varianten tonen',
  'cdp:product-card:variant-modal:title': 'Productvariant kiezen',
  'cdp:product-card:variant-modal:discount-info': '{couponCode} is succesvol toegevoegd',
  'cdp:product-card:variant-modal:product-not-available':
    'Het product is voor onbepaalde tijd niet beschikbaar.',

  'cdp:ab-test:product-card:additional-price-info': 'incl. {percentage}% abonnementskorting',
  'cdp:ab-test:product-card:additional-price-info:coupon': ' {couponCode} coupon',
  'cdp:ab-test:product-card:in-cart': 'In het winkelmandje',
  'cdp:filter:sorts:horse': 'Paard',
  'cdp:filter:desires:hypocare': 'Hypo',
  'cdp:pet-profile:gateway:dog:navigate:title': 'Wil je aanbevelingen voor je hond bekijken?',
  'cdp:pet-profile:gateway:cat:navigate:title': 'Wil je aanbevelingen voor je kat bekijken?',
  'cdp:pet-profile:gateway:navigate:title-with-name': 'Wil je aanbevelingen voor {name} bekijken?',
  'cdp:pet-profile:gateway:dog:navigate:text':
    'We hebben voeding en passende producten voor je hond samengesteld, zodat je sneller de juiste keuze kunt maken.',
  'cdp:pet-profile:gateway:cat:navigate:text':
    'We hebben voeding en passende producten voor je kat samengesteld, zodat je sneller de juiste keuze kunt maken.',
  'cdp:pet-profile:gateway:navigate:text-with-name':
    'We hebben voeding en passende producten voor {name} samengesteld, zodat je sneller de juiste keuze kunt maken.',
  'cdp:pet-profile:gateway:navigate:cta': 'Aanbevelingen bekijken',
  'cdp:pet-profile:gateway:login:cta': 'Inloggen',
  'cdp:pet-profile:gateway:dog:update:title': 'Heeft je hond ook {need}?',
  'cdp:pet-profile:gateway:cat:update:title': 'Heeft je kat ook {need}?',
  'cdp:pet-profile:gateway:update:title-with-name': 'Heeft {name} ook {need}?',
  'cdp:pet-profile:gateway:update:text':
    'We werken het profiel bij, zodat je nog beter passende aanbevelingen krijgt.',
  'cdp:pet-profile:gateway:update:cta': 'Profiel bijwerken',
  'cdp:pet-profile:gateway:dog:create-another:title': 'Heb je nog een hond?',
  'cdp:pet-profile:gateway:cat:create-another:title': 'Heb je nog een kat?',
  'cdp:pet-profile:gateway:dog:create-another:text':
    'Maak nog een profiel aan en ontvang passende aanbevelingen voor elk van je honden.',
  'cdp:pet-profile:gateway:cat:create-another:text':
    'Maak nog een profiel aan en ontvang passende aanbevelingen voor elk van je katten.',
  'cdp:pet-profile:gateway:create-another:cta': 'Nog een profiel aanmaken',
  'cdp:pet-profile:gateway:dog:create:title': 'Ontvang persoonlijke aanbevelingen voor je hond',
  'cdp:pet-profile:gateway:cat:create:title': 'Ontvang persoonlijke aanbevelingen voor je kat',
  'cdp:pet-profile:gateway:dog:create:text':
    'Maak een profiel aan, zodat we voeding en producten kunnen aanbevelen die bij je hond passen.',
  'cdp:pet-profile:gateway:cat:create:text':
    'Maak een profiel aan, zodat we voeding en producten kunnen aanbevelen die bij je kat passen.',
  'cdp:pet-profile:gateway:create:cta': 'Profiel aanmaken',
};
